import React,{ useEffect, useState }  from "react";
import Tablecomon from './view/_table';
import { Grid, Card, Typography, Button } from "@material-ui/core";
import moment from "moment";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles } from "@material-ui/core/styles";
import Datesdropdown from './view/_dates-dropdown';
import { useSelector,useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
const useStyle = makeStyles((theme) => ({
  heading:{
    backgroundColor: theme.palette.ePrimary?.base,
    color: "white",
    padding: "1.5% 3%",
  },
  dropdown:{
    display: "flex"
  },
  margin:{
    marginTop:"3%"
  },
  mainGrid: {
    flexFlow: "column",
    height: "100%"
  },
  contentGrid: {
    flexGrow: "1"
  }
}))
export default function E_Charges(props) {
  const useStyleClasses = useStyle();
    let currentDate = new Date();
    const [dateCategory , setDateCategory] = React.useState(1);
    let isPrepaidSa = useSelector((store) => store?.meterDetails?.getSaInfo?.isPrepaidSa);
    isPrepaidSa = isPrepaidSa === "Y" ? true : false;
    const PREPAID_BILL_LABEL= "Prepaid Bill";
    const POSTPAID_BILL_LABEL= "Postpaid Bill";
    const [isPrepaid, setIsPrepaid] = useState();
    useEffect(()=>{
      if(isPrepaidSa !== isPrepaid){
        setIsPrepaid(isPrepaidSa);
      }
    },[isPrepaidSa])
    if((typeof props.dateDropdownCategory !== 'string') && dateCategory !== props.dateDropdownCategory){
        setDateCategory(props.dateDropdownCategory);
    }
    const yearDateFromat = useSelector(
      (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
    );
    const billsandPaymentsAllData = props.billsandPaymentsData;
    let filterdDataOfCharge;
    if(billsandPaymentsAllData && typeof billsandPaymentsAllData !== 'string'){
        filterdDataOfCharge = billsandPaymentsAllData.filter(function (item)
          {
            return (item.label === PREPAID_BILL_LABEL || item.label === POSTPAID_BILL_LABEL);
          }
        );
    }
    // let ChargePaymentLabels = useSelector(
    //   (state) => state?.labels?.data?.getLabels?.E_BILLS_CHARGES_AND_PAYMENTS
    // );
    const { t: ChargePaymentLabels, ready: PaymentLabels } = useTranslation("label-E_BILLS_CHARGES_AND_PAYMENTS");
    let billsAndPaymentHistoryLabels = useSelector(
      (state) => state?.labels?.data?.getLabels?.BILLING_HISTORY
    );
    const browserName = useSelector((store) => store?.browserDetect?.browserName);
    function AddMonthsToCurrentDate(date, months) {
        date.setMonth(date.getMonth() + months);
        return date;
    }
    const [dateDropdownCategory, setDateDropdownCategory] = React.useState('1');
    const saStartDate= useSelector((state) => state?.meterDetails?.getSaInfo?.saStartDate);
    const dateDropdownChange = (event) => {
      setDateDropdownCategory(event.target.value);
      setDateCategory(event.target.value);
      if(event.target.value === 0) {
        props.setStartDate(saStartDate)
        props.setEndDate(moment().format('YYYY-MM-DD'));
      } else if(event.target.value === 1) {
        props.setStartDate(moment().startOf('month').format('YYYY-MM-DD'));
        props.setEndDate(moment().format('YYYY-MM-DD'));
      } else if(event.target.value === 2) {
        props.setStartDate(moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'));
        props.setEndDate(moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'));
      } else if(event.target.value === 3) {
        props.setStartDate(moment().subtract(3, 'months').format('YYYY-MM-DD'));
        props.setEndDate(moment().format('YYYY-MM-DD'));
      } else if(event.target.value === 4) {
        props.setStartDate(moment().subtract(6, 'months').format('YYYY-MM-DD'));
        props.setEndDate(moment().format('YYYY-MM-DD'));
      } else if(event.target.value === 5) {
        props.setStartDate(moment().subtract(1, 'year').format('YYYY-MM-DD'));
        props.setEndDate(moment().format('YYYY-MM-DD'));
      }
    }
    function FilterDateCategory(){
      let dd=props
        let filterDateCategoryArray=[];
        if(dateCategory === 0 && filterdDataOfCharge){
            filterDateCategoryArray=filterdDataOfCharge;
        }
        if(dateCategory === 1 && filterdDataOfCharge){
          const oldDate=moment().startOf('month').format(yearDateFromat);
          let newOldDate=moment(oldDate).subtract(1, "d").format(yearDateFromat);
          const todayDate=moment(new Date()).format(yearDateFromat);
          filterDateCategoryArray = filterdDataOfCharge.filter(function (item)
          {
              const objDate=item.date.substring(0, 10);
              return (moment(objDate,yearDateFromat).isAfter(newOldDate,yearDateFromat) && moment(objDate,yearDateFromat));
          }
          );
      }
        if(dateCategory === 2 && filterdDataOfCharge){
          const oldDate=moment().subtract(1, "months").startOf('month').format(yearDateFromat);
          let newOldDate=moment(oldDate).subtract(1, "d").format(yearDateFromat);
          const endOfDate = moment().subtract(1, "months").endOf('month').format(yearDateFromat)
          let newEndDate=moment(endOfDate).add(1, "d").format(yearDateFromat);
          const todayDate=moment(new Date()).format(yearDateFromat);
          filterDateCategoryArray = filterdDataOfCharge.filter(function (item)
          {
              const objDate=item.date.substring(0, 10);
              return (moment(objDate,yearDateFromat).isAfter(newOldDate,yearDateFromat) && moment(objDate,yearDateFromat).isBefore(newEndDate,yearDateFromat) && moment(objDate,yearDateFromat));
          }
          );
      }
        if(dateCategory === 3 && filterdDataOfCharge){
          const oldDate=moment(AddMonthsToCurrentDate(currentDate, -3)).format(yearDateFromat);
          let newOldDate=moment(oldDate).subtract(1, "d").format(yearDateFromat);
          const todayDate=moment(new Date()).format(yearDateFromat);
          filterDateCategoryArray = filterdDataOfCharge.filter(function (item)
          {
              const objDate=item.date.substring(0, 10);
              return (moment(objDate,yearDateFromat).isAfter(newOldDate,yearDateFromat) && moment(objDate,yearDateFromat));
          }
          );
      }
        if(dateCategory === 4 && filterdDataOfCharge){
            const oldDate=moment(AddMonthsToCurrentDate(currentDate, -6)).format(yearDateFromat);
            let newOldDate=moment(oldDate).subtract(1, "d").format(yearDateFromat);
            const todayDate=moment(new Date()).format(yearDateFromat);
            filterDateCategoryArray = filterdDataOfCharge.filter(function (item)
            {
                const objDate=item.date.substring(0, 10);
                return (moment(objDate,yearDateFromat).isAfter(newOldDate,yearDateFromat) && moment(objDate,yearDateFromat));
            }
            );
        }
        if(dateCategory === 5 && filterdDataOfCharge){
            const oldDate=moment(AddMonthsToCurrentDate(currentDate, -12)).format(yearDateFromat);
            let newOldDate=moment(oldDate).subtract(1, "d").format(yearDateFromat);
            const todayDate=moment(new Date()).format(yearDateFromat);
            filterDateCategoryArray = filterdDataOfCharge.filter(function (item)
            {
                const objDate=item.date.substring(0, 10);
                return (moment(objDate,yearDateFromat).isAfter(newOldDate,yearDateFromat) && moment(objDate,yearDateFromat));
            }
            );
        }
        return filterDateCategoryArray;
    }
    filterdDataOfCharge=FilterDateCategory();
    return(
        <Grid container className={useStyleClasses.mainGrid}>
         <Grid item container className={useStyleClasses.heading} >
            <Grid item xs={6} sm={6} lg={8} >
            {(!(typeof(isPrepaid) === "undefined") && isPrepaid)?(
                  <Typography variant="h6">
                    {PaymentLabels?ChargePaymentLabels("E_POSTPAID_CHARGES_TITLE"): <Skeleton />}
                  </Typography>
                  ):(
                  <Typography variant="h6" >
                    {PaymentLabels?ChargePaymentLabels("E_POSTPAID_BILL_TITLE"): <Skeleton />}
                  </Typography>
                  )}
            </Grid>
            <Grid container item xs={6} sm={6} lg={4} alignItems='center' justify="flex-end">
              <Grid item className={useStyleClasses.dropdown} spacing={1} justify="flex-end">
                <Datesdropdown props={props}  handler={dateDropdownChange} cat={dateDropdownCategory}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid 
            className={useStyleClasses.contentGrid}
            item
            style={{overflowY: browserName === "firefox" ? "auto" : "overlay"}}
          >
                    {props.isloading &&
              (<Typography variant="body1" className={useStyleClasses.margin}
              component="h2" align="center">{PaymentLabels?ChargePaymentLabels("E_LOADING_DATA"):<Skeleton />}...</Typography>)}
            {( !props.isloading && filterdDataOfCharge.length>0 )&&(
              <Tablecomon data={filterdDataOfCharge} tabName={props.tabName}/>
            )}
            {(!props.isloading && filterdDataOfCharge.length==0) &&
    (<Typography variant="body1" className={useStyleClasses.margin}
    component="h2" align="center">{PaymentLabels?ChargePaymentLabels("E_NO_DATA_AVAILABE"):<Skeleton />}</Typography>
                )}
          </Grid>
        </Grid>
    );
}
